<!--
 * @Author: lbh
 * @Date: 2022-03-02 14:16:22
 * @LastEditors: lbh
 * @LastEditTime: 2022-03-02 16:05:27
 * @Description: file content
-->
<template>
  <div
    class="scan-box"
    v-show="isScan"
    :class="isPc ? 'isPc' : ''"
    style="z-index:1000"
  >
    <div
      id="qr-reader"
      v-show="showScan"
    >

    </div>

    <van-icon
      name="clear"
      size="60"
      class="clear"
      v-show="showScan"
      @click="stopCameras"
    />
  </div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode';
import util from "@/js/util";
export default {
  name: "self-scan",
  props: {
    // 是否開始
    isScan: {
      default () {
        return false
      }
    }
  },
  model: {
    prop: "isScan",
    event: "click"
  },
  data () {
    return {
      Html5QrcodeObj: null,
      showScan: false,
      cameraId: "",
      isPc: false
    }
  },
  watch: {
    isScan () {
      if (this.isScan) {
        this.getCameras();
      }
    }
  },
  created () {
    this.isPc = util.IsPC();
  },
  methods: {
    // 獲取相機權限 , 判斷是否可以使用
    getCameras () {
      // 綁定容器
      this.Html5QrcodeObj = new Html5Qrcode('qr-reader');
      // 獲取權限
      Html5Qrcode.getCameras().then((devices) => {
        console.log(devices);
        // 拿到權限組
        if (devices && devices.length) {
          if (devices.length > 1) {
            this.cameraId = devices[1].id;
          } else {
            this.cameraId = devices[0].id;
          }
          console.log(this.cameraId);
          // 開啟掃碼
          this.start();
          // .. use this to start scanning.
        } else {
          alert('相機權限獲取失敗, 請允許本網站使用相機後,再嘗試掃碼!');
          this.$emit('click', false);
        }
      }).catch((err) => {
        // handle err
        console.log(err);
        alert('相機權限獲取失敗, 請允許本網站使用相機後,再嘗試掃碼!');
        this.$emit('click', false);
      });
    },
    // 啟動掃碼
    start () {
      // 展示容器
      this.showScan = true;
      setTimeout(() => {
        // 啟動掃碼
        this.Html5QrcodeObj.start(
          this.cameraId, // retreived in the previous step.
          {
            fps: 10, // 将帧速率设置为每秒10帧
            qrbox: { width: 250, height: 250 }, // 仅将取景器的250 X 250区域设置为可扫描、静止着色
          },
          (qrCodeMessage) => {
            // 掃碼成功, 獲取碼內容
            if (qrCodeMessage) {
              console.log(qrCodeMessage);
              // 停止掃碼
              this.stopCameras();
              this.$emit("scanResult", qrCodeMessage);
            }
          },
          (errorMessage) => {
            // 解析失敗, 這裡類似輪詢,  千萬不要彈窗
            console.log(errorMessage);
          },
        ).catch((err) => {
          // Start failed, handle it. For example,
          console.log(`Unable to start scanning, error: ${err}`);
        });
      }, 50);
    },
    stopCameras () {
      this.Html5QrcodeObj.stop().then((ignore) => {
        // QR Code scanning is stopped.
        console.log('QR Code scanning stopped.');
        // 隱藏 掃碼框
        this.showScan = false;
        this.$emit('click', false);
        // 清空容器
        // document.querySelector('#qr-reader').innerHTML = '';
      }).catch((err) => {
        // Stop failed, handle it.
        console.log('Unable to stop scanning.');
        this.$emit('click', false);
      });
    },
  }
}
</script>

<style lang="less" scoped>
.scan-box {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #000;
  width: 100%;
  &.isPc {
    position: absolute !important;
  }
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // #qr-reader {
  // top: 200px;
  // }
  .clear {
    color: #fff;
    position: absolute;
    bottom: 10px;
    left: calc(50% - 30px);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/scan.vue